const units = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

// TODO: do we need to translate bytes
export const formatBytes = (n: number | undefined) => {
  if (!n) return "0 B";

  let l = 0;
  while (n >= 1024 && ++l) {
    n = n / 1024;
  }

  return n.toFixed(n < 10 && l > 0 ? 1 : 0) + " " + units[l];
};
